/**
 * Open a PDF blob in a hidden iframe and trigger the browser print dialog.
 * The Job Queue's copy (task reports, routing slips, defective-sheet labels...); other pages use
 * utils/openPdfInPrintDialog.js, which has no cleanup.
 *
 * Single-shot cleanup so long-running kiosks don't accumulate iframes and blob URLs on every
 * print: onafterprint fires both on print success and when the user dismisses the dialog; the
 * 60 s backstop catches paths where onafterprint never fires (some browser cancel flows).
 */
export default function openPdfInPrintDialog(pdfBlob) {
  const blobUrl = URL.createObjectURL(pdfBlob);
  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = blobUrl;
  document.body.appendChild(iframe);

  let cleaned = false;
  const cleanup = () => {
    if (cleaned) return;
    cleaned = true;
    try { document.body.removeChild(iframe); } catch (e) { /* already gone */ }
    URL.revokeObjectURL(blobUrl);
  };

  iframe.onload = () => {
    setTimeout(() => {
      try {
        iframe.contentWindow.focus();
        iframe.contentWindow.onafterprint = cleanup;
        iframe.contentWindow.print();
      } catch (e) {
        cleanup();
      }
    }, 250);
  };

  setTimeout(cleanup, 60000);
}
